module.exports = __webpack_public_path__ + "media/images/emblems/Oberuzwil-coat_of_arms-1806ae49afbcf9b8307b68d732a41f59.svg";